import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAPIgetCustomerReport } from "../api/api-get-customer";
import CustomerFilter from "./CustomerFilter";
import CustomerList from "./CustomerList";
import { endOfMonth, format, set, startOfMonth } from "date-fns";
import { fi } from "date-fns/locale";

const CustomerReportMain = () => {
  const {
    data,
    loading,
    error,
    handleOnClickLoad,
    handleOnPage,
    filterValue,
    setFilterValue,
    paging,
  } = useAPIgetCustomerReport();
  const [searchParams, setSearchParams] = useSearchParams();

  const startDate = searchParams.get("start-date");
  const endDate = searchParams.get("end-date");

  useEffect(() => {
    if (startDate && endDate) {
      setFilterValue({
        ...filterValue,
        dari_tanggal: startDate,
        sampai_tanggal: endDate,
      });
    } else {
      setFilterValue({
        ...filterValue,
        dari_tanggal: format(startOfMonth(new Date()), "yyyy-MM-dd HH:mm:ss"),
        sampai_tanggal: format(endOfMonth(new Date()), "yyyy-MM-dd HH:mm:ss"),
      });
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (
      filterValue.dari_tanggal !== null &&
      filterValue.sampai_tanggal !== null
    ) {
      handleOnClickLoad();
    }
  }, [filterValue]);

  return (
    <div className="w-full col-center-start gap-4 p-4">
      <CustomerFilter
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        error={error}
        loading={loading}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
      <CustomerList
        data={data}
        filterValue={filterValue}
        loading={loading}
        paging={paging}
        handleOnPage={handleOnPage}
      />
    </div>
  );
};

export default CustomerReportMain;
